import { AxiosRequestConfig, AxiosResponse } from 'axios';
import {
    customerPlBookmakerList,
    customerPlCustomLeagueList,
    customerPlEventTypeList,
    customerPlLeagueLimitsList,
    customerPlList,
    customerPlMarketList,
    customerPlPeriodTypeList,
    customerPlSportList,
} from '@/api/customerPl';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IApiListParams } from '@/types/api';
import { CustomerPlSection, ICustomerPlApiListResponse, ICustomerPlFilters } from '@/types/customerPl';
import { IListParams } from '@/types/service';

type CustomerPlApiCall = (params: IApiListParams, config?: AxiosRequestConfig) => Promise<AxiosResponse<ICustomerPlApiListResponse>>;

const SECTION_API: Record<CustomerPlSection, CustomerPlApiCall> = {
    total: customerPlList,
    sport: customerPlSportList,
    periodType: customerPlPeriodTypeList,
    marketType: customerPlEventTypeList,
    market: customerPlMarketList,
    bookmaker: customerPlBookmakerList,
    leagueLimits: customerPlLeagueLimitsList,
    customLeague: customerPlCustomLeagueList,
};

export const customerPlService = {
    async list(section: CustomerPlSection, params: IListParams<ICustomerPlFilters>): Promise<AxiosResponse<ICustomerPlApiListResponse>> {
        try {
            return await baseListService<ICustomerPlApiListResponse>(SECTION_API[section], {
                ...params,
                requestKey: params.requestKey ?? `customer-pl:${section}`,
            });
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Customer P/L API Error:', e);
            throw new AppError(`Unable to load Customer P/L list, request error`, { cause: e });
        }
    },
};
